import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import { theme } from '../../legacy/style/theme';
import { SessionUsername, OrganizationName, Title } from '../../session/list-sessions/styles';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../../../types';
import { organizationQuery } from '../../../core/organization/queries';
import { userQuery } from '../../../core/authentication/queries';
import { formatDistance } from '../../../utils/numbers';
import { useMemo } from 'react';
import { roadSectionsQuery, selectedRoadSectionsQuery } from '../../../core/reference/queries';
import { ActionsOnSelectedRoadSections } from './ActionsOnSelectedRoadSections';
import { Header } from '../../design_system/page/Header';

export const ReferenceHeader = () => {
    const { t } = useTranslation();
    const roadSectionList = useSelector(roadSectionsQuery);
    const selectedRoadSections = useSelector(selectedRoadSectionsQuery);
    const organization = useAppSelector(organizationQuery);
    const user = useAppSelector(userQuery);

    const { count, totalDistance } = useMemo(() => {
        const meters = selectedRoadSections.reduce(
            (sum, roadSection) => sum + (roadSection.cumulEnd - roadSection.cumulStart),
            0,
        );

        return { count: selectedRoadSections.length, totalDistance: formatDistance(meters) };
    }, [selectedRoadSections]);

    return (
        <>
            <Grid container>
                <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100px' }} xs={3}>
                    <Title>{t('reference.yourReference')}</Title>
                    {roadSectionList && count > 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: '-24px' }}>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '18px', fontWeight: 600 }}>
                                {t('reference.selectedSections', { count })}
                            </Typography>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '14px', fontWeight: 500 }}>
                                {t('reference.totalDistance', { totalDistance })}
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Header />
                </Grid>
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        mt: '24px',
                        paddingRight: '6px',
                    }}
                    xs={3}
                >
                    <SessionUsername>
                        {user?.lastName} {user?.firstName}
                    </SessionUsername>
                    <OrganizationName>{organization?.name}</OrganizationName>
                </Grid>
            </Grid>
            <ActionsOnSelectedRoadSections />
        </>
    );
};
